import { useAppSelector } from "../../app/hooks";
import {
  selectCanRemoteAccessLeoForSite,
  selectCanRemoteAccessControllerForSite,
  selectCanViewRemoteAccessPorts,
} from "../../features/auth/authSlice";
import { useHowToAccessLeoAndControllerDialogs } from "../../hooks/appHooks/useHowToAccessLeoAndControllerDialogs";
import HowToDialog from "./HowToDialog";

type Props = {
  siteList: Array<number>;
  mobileScreen: boolean;
};
const HowToDialogs = ({ siteList, mobileScreen }: Props) => {
  const canRemoteAccessLeo = useAppSelector((state) =>
    siteList
      .map((siteId) => selectCanRemoteAccessLeoForSite(state, siteId))
      .some((bool) => bool),
  );
  const canRemoteAccessController = useAppSelector((state) =>
    siteList
      .map((siteId) => selectCanRemoteAccessControllerForSite(state, siteId))
      .some((bool) => bool),
  );
  const canViewRemoteAccessPort = useAppSelector((state) =>
    siteList
      .map((siteId) => selectCanViewRemoteAccessPorts(state, siteId))
      .some((bool) => bool),
  );

  const howToDialogs = useHowToAccessLeoAndControllerDialogs(
    mobileScreen,
    canRemoteAccessLeo,
    canRemoteAccessController,
    canViewRemoteAccessPort,
  );

  return (
    <>
      {howToDialogs.map(({ key, open, title, handleClose, howToSteps }) => (
        <HowToDialog
          key={`${key}-${mobileScreen ? "mobile" : "desktop"}`}
          open={open}
          title={title}
          handleClose={handleClose}
          howToSteps={howToSteps}
          isSmallDevice={mobileScreen}
        />
      ))}
    </>
  );
};

export default HowToDialogs;
